var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2040_5320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1973 35.2703H9.82751V37.2326H29.1973V35.2703Z",
    fill: "#FF973C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4136 39.18H6.11023L13.3227 25.5444H17.626L10.4136 39.18Z",
    fill: "#C31F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7663 39.18H33.0696L25.8572 25.5444H21.5538L28.7663 39.18Z",
    fill: "#C31F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3205 1.22563C23.5857 -0.408543 15.5945 -0.408543 7.85963 1.22563C6.05649 1.61338 4.61171 3.49564 4.61011 5.302V30.1408C4.61011 31.9504 6.08343 33.423 7.90042 33.4311H31.2789C33.0983 33.4229 34.5692 31.9504 34.5692 30.1408V5.302C34.5684 3.49564 33.1236 1.6117 31.3205 1.22563Z",
    fill: "#FF973C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9179 5.769V5.30373C32.9163 4.23201 31.9898 3.05905 30.9793 2.84026C27.2408 2.05176 23.4101 1.651 19.59 1.651C15.77 1.651 11.9376 2.05099 8.20569 2.83866C7.18861 3.05905 6.26221 4.23201 6.26221 5.30212V5.769C6.26213 5.769 32.9179 5.769 32.9179 5.769Z",
    fill: "#C31F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8404 27.6952C30.8404 28.8241 29.927 29.7375 28.7981 29.7375C27.6709 29.7375 26.7559 28.8241 26.7559 27.6952C26.7559 26.5679 27.6709 25.6529 28.7981 25.6529C29.927 25.6529 30.8404 26.5679 30.8404 27.6952Z",
    fill: "#C31F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4223 27.6952C12.4223 28.8241 11.5089 29.7375 10.38 29.7375C9.25275 29.7375 8.33936 28.8241 8.33936 27.6952C8.33936 26.5679 9.25275 25.6529 10.38 25.6529C11.5089 25.6529 12.4223 26.5679 12.4223 27.6952Z",
    fill: "#C31F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3043 3.76336C19.3043 4.49064 18.7158 5.07835 17.9893 5.07835C17.2636 5.07835 16.6743 4.4898 16.6743 3.76336C16.6743 3.03691 17.2636 2.44836 17.9893 2.44836C18.7166 2.44836 19.3043 3.03684 19.3043 3.76336Z",
    fill: "#FF973C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5041 3.76336C22.5041 4.49064 21.9156 5.07835 21.1891 5.07835C20.4627 5.07835 19.8741 4.4898 19.8741 3.76336C19.8741 3.03691 20.4619 2.44836 21.1891 2.44836C21.9164 2.44836 22.5041 3.03684 22.5041 3.76336Z",
    fill: "#FF973C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5926 8.4314H8.47669C7.76249 8.4314 7.18213 9.01015 7.18213 9.72435V17.5457C7.18213 18.2616 7.76249 18.8403 8.47669 18.8403H17.5926C18.3068 18.8403 18.8872 18.2615 18.8872 17.5457V9.72435C18.8872 9.01015 18.3068 8.4314 17.5926 8.4314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7017 8.4314H21.5874C20.8715 8.4314 20.2928 9.01015 20.2928 9.72435V17.5457C20.2928 18.2616 20.8716 18.8403 21.5874 18.8403H30.7017C31.4176 18.8403 31.9963 18.2615 31.9963 17.5457V9.72435C31.9963 9.01015 31.4175 8.4314 30.7017 8.4314Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2040_5320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.18,
    height: 39.18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.81270502d9ac7ab9dadc43f0f9014a9f.svg";
export { ForwardRef as ReactComponent };